import PropTypes from 'prop-types';
import React from 'react';
import './DefaultInput.style.scss';

const DefaultInput = (props) => {
  return (
    <input
      className="input-message-default"
      type="text"
      name="message"
      id="message"
      data-testid="message"
      onChange={props.onChange}
      value={props.value}
      autoComplete="off"
      placeholder={props.placeholder || 'Digite sua mensagem'}
    />
  );
};

DefaultInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string
};

export default DefaultInput;
